import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import PreviewEventSlider from './PreviewEventSlider';
import PreviewVirtualBoothSlider from './PreviewVirtualBoothSlider';
import axios from 'axios';
import { objectToFormData } from '../events/utils';
var App = /*#__PURE__*/function (_Component) {
  function App(props) {
    var _this;
    _classCallCheck(this, App);
    _this = _callSuper(this, App, [props]);
    _this.onClickPreviewButton = _this.onClickPreviewButton.bind(_this);
    _this.hidePreviewModal = _this.hidePreviewModal.bind(_this);
    _this.state = {
      eventContent: null,
      showPreviewModal: false,
      isLoading: false
    };
    var self = _this;
    $('.edit-event-button').on('click', function (e) {
      e.stopPropagation();
    });
    $('.my-event-row').on('click', function () {
      var event_id = $(this).attr('data-id');
      var payload = {
        action: 'get_event_by_id',
        post_id: event_id
      };
      self.setState({
        isLoading: true
      });
      axios.post(ajaxurl, objectToFormData(payload)).then(function (res) {
        var eventContent = {
          featured_image: {
            src: res.data.event_image[0],
            alt: res.data.title
          },
          virtual_event: res.data.virtual_event,
          durational: true,
          title: res.data.title,
          content: res.data.description,
          date: res.data.event_dates.length ? res.data.event_dates[0].event_date : false,
          start_time: res.data.event_dates.length ? res.data.event_dates[0].start_time : false,
          end_time: res.data.event_dates.length ? res.data.event_dates[0].end_time : false,
          event_themes: [],
          event_types: res.data.event_types,
          images: [{
            src: res.data.event_image[0],
            alt: res.title
          }
          // {
          //   src: res.data.listing_image[0],
          //   alt: res.title
          // }
          ],
          rsvp: {
            url: res.data.rsvp_link ? res.data.rsvp_link : ''
          },
          link: {
            title: 'event link',
            url: res.data.event_url ? res.data.event_url : '',
            target: '_blank'
          },
          participants: res.data.participants,
          supportEvents: res.data.supportEvents,
          isAvailableSubmit: false
        };
        self.setState({
          eventContent: eventContent,
          showPreviewModal: true,
          isLoading: false
        });
      });
    });
    return _this;
  }
  _inherits(App, _Component);
  return _createClass(App, [{
    key: "hidePreviewModal",
    value: function hidePreviewModal() {
      this.setState({
        showPreviewModal: false,
        eventContent: null
      });
    }
  }, {
    key: "onClickPreviewButton",
    value: function onClickPreviewButton() {
      var event_title = $('input[name="acf[_post_title]"]').val();
      var event_subtitle = $('input[name="acf[field_61082ceb5835c]"]').val();
      var event_description = $('textarea[name="acf[field_6101af2029977]"]').val() || $('textarea[name="acf[field_610c4a329ca34]"]').val();
      var event_types = null;
      var event_dates = [];
      var dates = [];
      var end_date = null;
      var startTimes = [];
      var endTimes = [];
      var event_images = [];
      var participants = [];
      var event_location = $('input[name="acf[field_6102d3958f7ad]"]').val();
      var access_instructions = $('textarea[name="acf[field_614241bdb9291]"]').val();
      var event_url = $('input[name="acf[field_6102d3a78f7ae]"]').val();
      var event_type = $('div.acf-field-6102d45ac985c label.selected input').val();
      var project_website_url = $('input[name="acf[field_6102d6f7c9864]"]').val() || $('input[name="acf[field_610c49dd9ca2f]"]').val();
      var virtual_event = $('input[name="acf[field_6102d33c8f7ac]"]:checked').val();
      var supportEvents = [];
      var event_length = $('input[name="acf[field_6102d45ac985c]"]:checked').val();
      switch (event_length) {
        case 'single':
          if ($('input[name="acf[field_610445bf88bbe]"]').val()) {
            var date = $('input[name="acf[field_610445bf88bbe]"]').val();
            dates.push("".concat(date.substring(0, 4), "-").concat(date.substring(4, 6), "-").concat(date.substring(6, 8)));
          }
          var start_time = $('input[name="acf[field_6102d59bc985f]"]').val();
          if (start_time) {
            startTimes.push(start_time);
          }
          var end_time = $('input[name="acf[field_6104437ebeafd]"]').val();
          if (end_time) {
            endTimes.push(end_time);
          }
          break;
        case 'multiple':
          var date_wrappers = $('input[id*="-field_6101afb0bb2fb"]');
          for (var i = 0; i < date_wrappers.length; i++) {
            var _date = $(date_wrappers[i]).val();
            if (_date.length > 4) {
              dates.push("".concat(_date.substring(0, 4), "-").concat(_date.substring(4, 6), "-").concat(_date.substring(6, 8)));
            }
          }
          var start_time_wrappers = $('input[id*="-field_6101b049bb2fc"]');
          for (var _i = 0; _i < start_time_wrappers.length; _i++) {
            var _start_time = $(start_time_wrappers[_i]).val();
            if (_start_time) {
              startTimes.push(_start_time);
            }
          }
          var end_time_wrappers = $('input[id*="-field_6101b065bb2fd"]');
          for (var _i2 = 0; _i2 < end_time_wrappers.length; _i2++) {
            var _end_time = $(end_time_wrappers[_i2]).val();
            if (_end_time) {
              endTimes.push(_end_time);
            }
          }
          break;
        case 'range':
          if ($('input[name="acf[field_6102d535c985d]"').val()) {
            var _date2 = $('input[name="acf[field_6102d535c985d]"]').val();
            dates.push("".concat(_date2.substring(0, 4), "-").concat(_date2.substring(4, 6), "-").concat(_date2.substring(6, 8)));
          }
          if ($('input[name="acf[field_6104435dbeafc]"]').val()) {
            var _date3 = $('input[name="acf[field_6104435dbeafc]"]').val();
            end_date = "".concat(_date3.substring(0, 4), "-").concat(_date3.substring(4, 6), "-").concat(_date3.substring(6, 8));
          }
          start_time = $('input[name="acf[field_6102d59bc985f]"]').val();
          if (start_time) {
            startTimes.push(start_time);
          }
          end_time = $('input[name="acf[field_6104437ebeafd]"]').val();
          if (end_time) {
            endTimes.push(end_time);
          }
          break;
        default:
      }
      var event_types_wrapper = $('select[name="acf[field_61019cf3ecc1f]"] option');
      if (event_types_wrapper.length > 0) {
        var event_type_name = $(event_types_wrapper[event_types_wrapper.length - 1]).html();
        var event_type_id = $(event_types_wrapper[event_types_wrapper.length - 1]).attr('value');
        event_types = [{
          name: event_type_name,
          id: event_type_id
        }];
      }
      var event_image = '';
      var img = $('div.acf-field[data-key="field_5d44946755dce"] img');
      if (img.length > 0) {
        event_image = $('div.acf-field[data-key="field_5d44946755dce"] img').attr('src');
        if (event_image.length > 1) {
          event_images.push({
            src: event_image,
            alt: event_title
          });
        }
      } else {
        event_image = $('.acf-gallery-main img');
        if (event_image.length > 1) {
          event_image.each(function (i, image) {
            event_images.push({
              src: image.src,
              alt: image.alt
            });
          });
        }
      }
      var listing_image = '';
      var listing_img = $('div.acf-field[data-key="field_61019a86ecc1e"] img');
      if (listing_img.length > 0) {
        listing_image = $('div.acf-field[data-key="field_61019a86ecc1e"] img').attr('src');
        if (listing_image.length > 1) {
          // event_images.push({
          //   src: listing_image,
          //   alt: event_title
          // });
        }
      }
      var location_address = false;
      if ($('input[name="acf[field_610ab9f5d130a]"]').length && $('input[name="acf[field_610ab9f5d130a]"]').val() !== '') {
        location_address = JSON.parse($('input[name="acf[field_610ab9f5d130a]"]').val());
      }
      var location_name = $('input[name="acf[field_614242c3b9292]"]').val();
      var social = [];
      var instagram = $('input[name="acf[field_61095669593be][field_61095674593bf]"], input[name="acf[field_610c49f49ca30][field_610c49fd9ca31]"]').val();
      if (instagram) {
        social.push({
          type: 'instagram',
          link: instagram
        });
      }
      var tiktok = $('input[name="acf[field_61095669593be][field_6109567b593c0]"], input[name="acf[field_610c49f49ca30][field_610c4a069ca32]"]').val();
      if (tiktok) {
        social.push({
          type: 'tiktok',
          link: tiktok
        });
      }
      var facebook = $('input[name="acf[field_61095669593be][field_610ab6f4f8f90]"]').val();
      if (facebook) {
        social.push({
          type: 'facebook',
          link: facebook
        });
      }
      var contactInfo = {};
      var contactEmail = $('input[name="acf[field_610c4a719ca35][field_610c4a839ca36]"]').val();
      if (contactEmail) {
        contactInfo.email = contactEmail;
      }
      var contactPhone = $('input[name="acf[field_610c4a719ca35][field_610c4a899ca37]"]').val();
      if (contactPhone) {
        contactInfo.phone = contactPhone;
      }
      var rsvp_link = $('input[name="acf[field_5b719dfaf20c0]"]').val();
      var participants_names = [];
      var participants_bios = [];
      var participants_name_wrappers = $('input[id*="-field_5f735e538e3f9"]');
      for (var _i3 = 0; _i3 < participants_name_wrappers.length; _i3++) {
        var participant_name = $(participants_name_wrappers[_i3]).val();
        participants_names.push(participant_name);
      }
      var participants_bio_wrappers = $('textarea[name*="[field_5f735e5a8e3fa]"]');
      for (var _i4 = 0; _i4 < participants_bio_wrappers.length; _i4++) {
        var participant_bio = $(participants_bio_wrappers[_i4]).val();
        participants_bios.push(participant_bio);
      }
      for (var _i5 = 0; _i5 < participants_names.length; _i5++) {
        if (participants_names[_i5].length > 0 || participants_bios[_i5].length > 0) {
          participants.push({
            name: participants_names[_i5],
            bio: participants_bios[_i5]
          });
        }
      }
      var supporting_event_name_wrappers = $('input[id*="-field_6101b124dec81"]');
      var supporting_event_types_wrapper = $('select[id*="-field_6101b135dec82"] option');
      var supporting_event_date_wrappers = $('input[id*="-field_6101b18ddec83"]');
      var supporting_event_start_time_wrappers = $('input[id*="-field_6101b19edec84"]');
      var supporting_event_end_time_wrappers = $('input[id*="-field_6101b1a6dec85"]');
      var supporting_event_url_wrappers = $('input[id*="-field_614243de81ff9"]');
      var supporting_event_location_wrappers = $('input[name*="[field_6117d18b3d2c4]"]');
      for (var _i6 = 0; _i6 < supporting_event_name_wrappers.length; _i6++) {
        var support_event_types = [];
        var support_event_type_name = $(supporting_event_types_wrapper[_i6]).html();
        var support_event_type_id = $(supporting_event_types_wrapper[_i6]).attr('value');
        if (support_event_type_name && support_event_type_name.length > 0) {
          support_event_types = [{
            name: support_event_type_name,
            id: support_event_type_id
          }];
        }
        var supporting_event = $(supporting_event_name_wrappers[_i6]).val();
        var supporting_date = $(supporting_event_date_wrappers[_i6]).val();
        var supporting_start_time = $(supporting_event_start_time_wrappers[_i6]).val();
        var supporting_end_time = $(supporting_event_end_time_wrappers[_i6]).val();
        var supporting_url = $(supporting_event_url_wrappers[_i6]).val();
        var supporting_location = $(supporting_event_location_wrappers[_i6]).val() ? JSON.parse($(supporting_event_location_wrappers[_i6]).val()) : null;
        supportEvents.push({
          event: supporting_event,
          date: supporting_date.length > 1 ? "".concat(supporting_date.substring(0, 4), "-").concat(supporting_date.substring(4, 6), "-").concat(supporting_date.substring(6, 8)) : "",
          event_types: support_event_types,
          start_time: supporting_start_time,
          end_time: supporting_end_time,
          url: supporting_url,
          location: supporting_location
        });
      }
      var eventContent = {
        featured_image: {
          src: event_image,
          alt: event_title
        },
        contactInfo: contactInfo,
        project_url: project_website_url,
        virtual_event: virtual_event,
        durational: event_type == 'durational',
        title: event_title,
        content: event_description,
        location_name: location_name,
        location_address: location_address,
        access_instructions: access_instructions,
        date: dates,
        end_date: end_date,
        start_time: startTimes,
        end_time: endTimes,
        event_themes: [],
        event_types: event_types,
        images: event_images,
        rsvp: {
          url: rsvp_link
        },
        social: social,
        participants: participants,
        link: {
          title: 'event link',
          url: event_url,
          target: '_blank'
        },
        supportEvents: supportEvents,
        isAvailableSubmit: true
      };
      this.setState({
        eventContent: eventContent,
        showPreviewModal: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var showPreviewModal = this.state.showPreviewModal;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-preview",
        type: "button",
        onClick: this.onClickPreviewButton
      }, "Preview Event"), showPreviewModal && $('.event-form').data('type') !== 'discover' ? /*#__PURE__*/React.createElement(PreviewEventSlider, {
        key: "preview-event-slider",
        eventContent: this.state.eventContent,
        dismissPreviewModal: this.hidePreviewModal
      }) : '', showPreviewModal && $('.event-form').data('type') === 'discover' ? /*#__PURE__*/React.createElement(PreviewVirtualBoothSlider, {
        key: "preview-event-slider",
        eventContent: this.state.eventContent,
        dismissPreviewModal: this.hidePreviewModal
      }) : '', this.state.isLoading ? /*#__PURE__*/React.createElement("div", {
        className: "loading-status"
      }, "Loading Event...") : '');
    }
  }]);
}(Component);
if (document.getElementById('preview-wrapper')) {
  ReactDOM.render( /*#__PURE__*/React.createElement(App, null), document.getElementById('preview-wrapper'));
}